import React, { useState } from 'react';
import styles from './PaymentModal.module.css';
import RussianCardPayment from './RussianCardPayment';

const PaymentModal = ({ isOpen, onClose }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  if (!isOpen) return null;

  const handleStripeClick = () => {
    // Stripe перенаправит на https://annavision.me/9palaces/thank-you после оплаты
    // Клиент сам вводит email при оплате
    window.location.href = 'https://buy.stripe.com/3cI00j3V9g5F0IO2ms77O05';
  };

  const handleRussianCardClick = () => {
    setSelectedPaymentMethod('russian');
  };

  const handleBack = () => {
    setSelectedPaymentMethod(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose} aria-label="Закрыть">
          ×
        </button>
        
        {selectedPaymentMethod === 'russian' ? (
          <>
            <h2 className={styles.title}>Оплата русской картой</h2>
            <p className={styles.subtitle}>Персональный прогноз по 9 Дворцам на 2026 год - 21739 ₽</p>
            <RussianCardPayment onBack={handleBack} />
            <p className={styles.note}>
              После оплаты вы получите подтверждение на email. Расчет прогноза займет 21 день.
            </p>
          </>
        ) : (
          <>
            <h2 className={styles.title}>Выберите способ оплаты</h2>
            <p className={styles.subtitle}>Персональный прогноз по 9 Дворцам на 2026 год - $269</p>
            
            <div className={styles.paymentOptions}>
              <button className={styles.paymentButton} onClick={handleStripeClick}>
                <div className={styles.buttonContent}>
                  <div className={styles.buttonIcon}>💳</div>
                  <div className={styles.buttonText}>
                    <div className={styles.buttonTitle}>Оплатить картой заграничной</div>
                    <div className={styles.buttonDescription}>Visa, MasterCard, American Express</div>
                  </div>
                  <div className={styles.buttonArrow}>→</div>
                </div>
              </button>

              <button className={styles.paymentButton} onClick={handleRussianCardClick}>
                <div className={styles.buttonContent}>
                  <div className={styles.buttonIcon}>🏦</div>
                  <div className={styles.buttonText}>
                    <div className={styles.buttonTitle}>Оплатить русской картой</div>
                    <div className={styles.buttonDescription}>МИР, Visa, MasterCard (РФ)</div>
                  </div>
                  <div className={styles.buttonArrow}>→</div>
                </div>
              </button>
            </div>

            <p className={styles.note}>
              После оплаты вы получите подтверждение на email. Расчет прогноза займет 21 день.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;

